<template>
  <div style="display: flex;">
    <div class="col-lg-12 col-md-12 col-sm-12 padding-div-low">      
      <div>
        <h5>Jueces</h5>
        <hr />
        <table class="table table-striped table-light table-hover">
          <thead class="thead-dark">
            <tr>
              <th class="text-center">Nombre</th>
              <th class="text-center">Tipo</th>              
            </tr>
          </thead>
          <tbody class="text-dark">
            <tr v-for="Juez in Datos.Jueces">
              <td>{{Juez.Nombre}}</td>
              <td>{{Juez.Tipo.Nombre}}</td>              
            </tr>
          </tbody>
        </table>
      </div>
      <br/>
      <div>
        <h5>Relaciones</h5>
        <hr />
        <table class="table table-striped table-light table-hover">
          <thead class="thead-dark">
            <tr>
              <th class="text-center">Imputado</th>
              <th class="text-center">Victima</th>
              <th class="text-center">Delito</th>
            </tr>
          </thead>
          <tbody class="text-dark">
            <tr v-for="Relacion in Datos.Relaciones">
              <td>{{Relacion.Imputado}}</td>
              <td>{{Relacion.Victima}}</td>
              <td>{{Relacion.Delito.Nombre}}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <br/>
      <div>
        <h5>Sesiones</h5>
        <hr />
        <table class="table table-striped table-light table-hover">
          <thead class="thead-dark">
            <tr>
              <th class="text-center">Sala</th>
              <th class="text-center">Inicio</th>
              <th class="text-center">Fin</th>
              <th class="text-center">Prueba realizada</th>
              <th class="text-center">¿Los videos fueron creados?</th>
              <th class="text-center">Localización</th>
              <th></th>
               <th></th>
            </tr>
          </thead>
          <tbody class="text-dark">
            <tr v-for="Sesion in Datos.Sesiones">
              <td class="text-center">{{Sesion.Sala.Nombre}}</td>
              <td class="text-center">{{Sesion.FechaDeInicio}}</td>
              <td class="text-center">{{Sesion.FechaDeFinalizacion}}</td>
              <td class="text-center">
                <i class="fas fa-check" v-if="Sesion.PruebaRealizada" title="Prueba realizada"></i>
                <i class="fas fa-times" v-if="!Sesion.PruebaRealizada" title="Prueba no realizada"></i>
                <a v-if="Sesion.VideoDePruebaRealizado" v-on:click="verVideoDePrueba(Sesion.SesionDeLaAudienciaId)" title="Ver vídeo de prueba">
                  <i class="fas fa-video"></i>
                </a>
              </td>
              <td class="text-center" v-if="Sesion.SeHanCreadoLosVideos == false">No</td>
              <td class="text-center" v-else>Si</td>
              <td class="text-center">{{Sesion.LocalizacionDeLosVideos.Nombre}}</td>
              <td>
                <a v-on:click="descargarVideo(Sesion)" title="Descargar vídeo de audiencia">
                  <i class="fas fa-download"></i>
                </a>
                <a v-on:click="complementarSesionDeLaAudiencia(Sesion.SesionDeLaAudienciaId)"  title="Abre la sesión para poder crear los videos y visualizarlos.">
                  <i class="fas fa-clipboard-check"></i>
                </a>
              </td>
              <td>
                <a v-on:click="ejecutaMergeDeLaGrabacion(Sesion)"  title="Consolidar Video Final de Sesión.">
                  <i class="fas fa-cogs"></i>
                 <!--<i class="fas fa-wrench"></i>-->                  
                </a>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="justify-content-end text-right">
            <button v-if="nVideos > 1" class="btn btn-dark" v-on:click="concatenarVideosYDescargar()" >Unir Videos de las Sesiones y Descargar</button>
            <button class="btn btn-primary" v-on:click="agregarSesionConfirmacion()">Agregar sesión y reabrir audiencia</button>
        </div>
      </div>            
      <br />
      <div>
        <h5>Permisos de acceso</h5>
        <hr />
        <div class="row">
          <div id="NombreDePrueba_div" class="col-lg-12 col-md-3 col-sm-3">
            <label for="PersonaAutorizada">Persona autorizada</label>
            <input type="text" class="form-control" placeholder="Ingrese nombre completo" id="PersonaAutorizada" v-model="NombrePersonaAutorizada" />
          </div>
          <!--<div id="NombreDePrueba_div" class="col-lg-12 col-md-3 col-sm-3">
            <label for="PersonaRecibe">Persona que recibe</label>
            <input type="text" class="form-control" placeholder="Ingrese nombre completo" id="PersonaRecibe" v-model="NombrePersonaQueRecibe" />
          </div>
          <div id="TiposDeDocumentos_div" class="col-lg-4 col-md-3 col-sm-3">
            <label for="Entregado">Entregado</label>
            <SiNo v-on:valorParaElPadre="cambioEntregado" :prefijo="enumeraciones.etiquetasDeHTML.Select" :tipo="enumeraciones.tiposDeSelect.Seleccione" :valorDefinido="Entregado" :key="Entregado"></SiNo>
          </div>
          <div id="TiposDeDocumentos_div" class="col-lg-4 col-md-3 col-sm-3">
            <label for="NombreDePrueba">Tipo de identificación</label>
            <C038TiposIdentificacion v-on:valorParaElPadre="cambioTipoIdentificacion" :valorDefinido="TipoIdentificacionId != undefined && TipoIdentificacionId != null ? TipoIdentificacionId : -1" :key="TipoIdentificacionId != undefined && TipoIdentificacionId != null ? TipoIdentificacionId : -1" :prefijo="enumeraciones.etiquetasDeHTML.Select" :tipo="enumeraciones.tiposDeSelect.Seleccione" :idDelInput="'VerificarAudiencia_TipoDeIdentificacion'"></C038TiposIdentificacion>
          </div>
          <div id="NombreDePrueba_div" class="col-lg-4 col-md-3 col-sm-3">
            <label for="NombreDePrueba">Folio</label>
            <input type="text" class="form-control" placeholder="Ingrese el folio" v-model="Folio" />
          </div>-->
          <div class="col-lg-12 col-md-12 col-sm-12 text-right">
            <br />
            <button class="btn btn-primary" v-on:click="limpiarDatos">Limpiar datos</button>
            <button class="btn btn-primary" v-on:click="agregarPermiso">Guardar permiso</button>
          </div>
        </div>
        <br />
        <table class="table table-striped table-light table-hover">
          <thead class="thead-dark">
            <tr>
              <th class="text-center">Persona autorizada</th>
              <!--<th class="text-center">Persona que recibe</th>
              <th class="text-center">Tipo de identificación</th>
              <th class="text-center">Folio de identificación</th>
              <th class="text-center">Fecha de entrega</th>
              <th class="text-center">Entregado</th>-->
              <th></th>
            </tr>
          </thead>
          <tbody class="text-dark">
            <tr v-if="Datos.Permisos.length <= 0">
              <td colspan="2" class="text-center">Sin personas autorizadas</td>
            </tr>
            <tr v-else v-for="Permiso in Datos.Permisos">
              <td class="text-left">{{Permiso.NombrePersonaAutorizada}}</td>
              <!--<td class="text-center">{{Permiso.NombrePersonaQueRecibe}}</td>
  <td class="text-center">{{Permiso.TipoIdentificacion.Nombre}}</td>
  <td class="text-center">{{Permiso.Folio}}</td>
  <td class="text-center">{{Permiso.FechaDeEntrega}}</td>
  <td class="text-center" v-if="Permiso.Entregado"><i class="fas fa-check"></i></td>
  <td class="text-center" v-if="!Permiso.Entregado"><i class="fas fa-times"></i></td>-->
              <td align="center">
                <i class="fas fa-edit" v-on:click="editarPermiso(Permiso)" title="Editar permiso"></i>
                <i class="fas fa-trash" v-on:click="quitarPermiso(Permiso.PermisoId)" title="Eliminar permisos"></i>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="text-right">
          <button class="btn btn-primary" v-on:click="finalizarAudiencia">Finalizar audiencia</button>
        </div>
      </div>            
    </div>
  </div>
</template>

<script>
  //Importaciones estandarizadas
  import plantilla from '@/../static/js/plantillas'
  import enumeraciones from '@/../static/js/enumeraciones'
  import comun from '@/../static/js/comun'
  import catalogos from '@/../static/js/catalogos'
  import api from '@/../static/js/api'
  import axios from 'axios'
  import router from '@/router/index'

  export default {
    components:{
      C038TiposIdentificacion: catalogos.PJ.C038TiposIdentificacion,
      SiNo: catalogos.Comunes.SiNo,
    },
    data() {
      return {
        comun,
        enumeraciones,
        Audiencia: [],
        PermisoId:Number,
        Entregado: 1,
        NombrePersonaAutorizada: "",
        NombrePersonaQueRecibe: "",
        Folio: 0,
        TipoIdentificacionId: -1,
        Datos: {
          Jueces: [
            {
              Nombre: String,
              Tipo: {
                Nombre: String
              }
            }
          ],
          Relaciones: [
            {
              Imputado: String,
              Victima: String,
              Delito: {
                Nombre: String
              }
            }
          ],
          Sesiones: [
            {
              Sala: {
                Nombre: String
              },
              Prueba: Boolean,
              FechaDeInicio: Object,              
              FechaDeFinalizacion: Object,
              SeHanCreadoLosVideos: Boolean, 
              LocalizacionDeLosVideos: Boolean
            }            
          ],
          Permisos: [
            {              
              NombreCompleto: String,
              //NombreCompletoDeQuienLoRecibio: String,
              Entregado: false,
              //TipoIdentificacion: {
              //  TipoIdentificacionId: Number
              //},
              //FolioDeLaIdentificacion: String
            }
          ]
        },
        nVideos : 0        
      }
    },
    props: {
      AudienciaId: Number
    },
    methods: {
      descargarVideo: function(sesion){                
        if(sesion.RutasDeVideos[0].RutaEnServidor != null)
          window.open(api.conexion + api.Comun.funcion.DescargarArchivo + "?rutaDelArchivo="+sesion.RutasDeVideos[0].RutaEnServidor, '_blank');
        else if(sesion.RutasDeVideos[0].Ruta != null)
          window.open(api.conexion + api.Comun.funcion.DescargarArchivo + "?rutaDelArchivo="+sesion.RutasDeVideos[0].Ruta, '_blank');
        else
          comun.mensajeDeAlerta("No hay ruta de vídeo para descargar.<br />El folio de la sesión es " + sesion.SesionDeLaAudienciaId, null, null);
      },
      agregarSesionConfirmacion: function () {
        bootbox.confirm({
          title: "Mensaje del sistema",
          message: "¿Desea agregar una sesión y reabrir la audiencia?",
          buttons: {
            cancel: {
              label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
            },
            confirm: {
              label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Aceptar'
            }
          },
          callback: (respuesta) => {
            if (respuesta) {
              this.agregarSesion();
            }
          }
        });
      },
      agregarSesion: function () {
        comun.SeEstaCargandoInformacion(true);
        const parametros = {
          AudienciaId: this.Audiencia.AudienciaId,
          EsPrueba: this.enumeraciones.EsPrueba
        }
        
        axios.post(
          api.conexion + api.Forseti.sistema.audiencias.audienciasPorVerificar.AgregarSesion,
          parametros,
          comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
        ).then(respuesta => {
          if (respuesta.data.SiHayError) {
            console.log(respuesta);
            comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
          } else {
            comun.SeEstaCargandoInformacion(false);
            comun.mensajeDeAlerta("La sesión se ha agregado correctamente.<br />Se redirigió a 'Panel de audiencias pendientes'.", null, null);
            var objeto = {
              "PartidoJudicialId" : this.Audiencia.PartidoJudicial.PartidoJudicialId,
              "AreaId": this.Audiencia.Area.AreaId,
              "MateriaId": this.Audiencia.Materia.MateriaId,
              "SalaId": this.Audiencia.Sala.SalaId
            }
            router.push({ name: 'PanelDeAudienciasPendientes', params: {Busqueda: objeto} });            
          }          
        }
        ).catch(excepcion => {
          console.log(excepcion);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
          comun.SeEstaCargandoInformacion(false);
        });
      },
      verVideoDePrueba: function(sesionDeLaAudienciaId){        
        router.push({ name: "VisorVideoPrueba", params: { SesionId: sesionDeLaAudienciaId } });
      },
      complementarSesionDeLaAudiencia: function (sesionDeLaAudienciaId) {                
        let audienciaId = this.Audiencia.AudienciaId;

        bootbox.confirm({
          title: "Mensaje del sistema",
          message: "¿Complementar la sesión de la audiencia?",
          buttons: {
            cancel: {
              label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
            },
            confirm: {
              label: '<i class="fa fa-check"></i>&nbsp;&nbsp; Aceptar'
            }
          },
          callback: function (respuesta) {
            if (respuesta) {               
              router.push({ name: "EdicionVideo", params: { SesionDeLaAudienciaId: sesionDeLaAudienciaId, AudienciaId: audienciaId  } });
            }
          }
        });
      },      
      finalizarAudiencia: function () {
        //Se cambia para hacer la verificación de las sesiones automáticamente al finalizar la audiencia.
        if(this.validaQueLasSesionesSeHayanCreadoLosVideos()) {
          bootbox.confirm({
          title: "Mensaje del sistema",
          message: "Al finalizar la audienicia los archivos orginales de audio y vídeo serán eliminados ¿Desea continuar?",
          buttons: {
            cancel: {
              label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
            },
            confirm: {
              label: '<i class="fa fa-check"></i>&nbsp;&nbsp; Aceptar'
            }
          },
          callback: (respuesta) => { 
            comun.SeEstaCargandoInformacion(true);
            const parametros = {
              Audiencia: this.Audiencia,
              EsPrueba: this.enumeraciones.EsPrueba
            }

            axios.post(
              api.conexion + api.Forseti.sistema.audiencias.audienciasPorVerificar.FinalizarAudiencia,
              parametros,
              comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
            ).then(respuesta => {
              if (respuesta.data.SiHayError) {
                console.log(respuesta);
                comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
              } else {
                comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
                router.push({ name: "PanelDeAudienciasPorVerificar" });
              }

              comun.SeEstaCargandoInformacion(false);
            }
            ).catch(excepcion => {
              console.log(excepcion);
              comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
              comun.SeEstaCargandoInformacion(false);
            });
          }
          });
        } else {
          comun.mensajeDeAlerta("No se han verificado todas las sesiones de la audiencia.<br />Revise las sesiones para poder continuar.", null, null);
        }
      },
      validaQueLasSesionesSeHayanCreadoLosVideos: function() {
        let finalizarAudiencia = true;
        this.Audiencia.SesionesDeLasAudiencias.forEach((sesionDeLaAudiencia, index) => { 
          if(sesionDeLaAudiencia.SeHanCreadoLosVideos == false)
            finalizarAudiencia = false;
          // sesionDeLaAudiencia.RutasDeVideos.forEach((element) => { 
          //     if (element.Camara.TipoCamara.TipoCamaraId == enumeraciones.camaras.HandyCam)
          //       finalizarAudiencia = true;
          //   })
        })

        return finalizarAudiencia;
      },
      limpiarDatos() {
        this.PermisoId = 0;
        this.NombrePersonaAutorizada = "";
        this.NombrePersonaQueRecibe = "";
        this.Entregado = 1;
        this.Folio = 0;
        this.TipoIdentificacionId = -1;
      },
      editarPermiso(Permiso) {        
        this.PermisoId = Permiso.PermisoId;
        this.NombrePersonaAutorizada = Permiso.NombrePersonaAutorizada;
        this.NombrePersonaQueRecibe = Permiso.NombrePersonaQueRecibe;
        this.Entregado = Permiso.Entregado == true ? 1 : 0;
        this.Folio = Permiso.Folio;
        //this.TipoIdentificacionId = Permiso.TipoIdentificacion.TipoIdentificacionId;
      },
      quitarPermiso(PermisoId) {
        comun.SeEstaCargandoInformacion(true);        
        let _this = this;

        let peticion = {
          PermisoId: PermisoId          
        }

        axios.post(api.conexion + api.Forseti.sistema.audiencias.audienciasPorVerificar.QuitararPermisoEnAudienciaPorVerificar,
          peticion,
          comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
        ).then(async respuesta => {
          if (respuesta.data.SiHayError) {
            console.log(respuesta);
            comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
          } else {
            this.busquedaAudiencia();
            this.limpiarDatos();
            comun.mensajeDeAlerta("El permiso se quitó correctamente.", null, null);
          }
          comun.SeEstaCargandoInformacion(false);
        })
          .catch(e => {
            console.log("No Hay Respuesta del Servidor", e);
            comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
          });
      },
      cambioEntregado(datos) {        
        this.Entregado = parseInt(datos.target.value);
      },
      cambioTipoIdentificacion(datos) {
        this.TipoIdentificacionId = parseInt(datos.target.value);
      },
      crearPermiso() {        
        let permiso =  {
          PermisoDeLaAudienciaId: this.PermisoId,
          NombreCompleto: this.NombrePersonaAutorizada,
          Entregado: false,          
          //NombreCompletoDeQuienLoRecibio: this.NombrePersonaQueRecibe,
          //TipoIdentificacion: { TipoIdentificacionId: this.TipoIdentificacionId },
          //FolioDeLaIdentificacion: this.Folio,
          Activo: true
        }

        //if (this.Entregado == 1)
        //  permiso.FechaDeEntrega = moment();

        return permiso;
      },
      agregarPermiso() {        
        comun.SeEstaCargandoInformacion(true);
        let _this = this;

        let peticion = {
          PermisoDeLaAudiencia: this.crearPermiso(),
          AudienciaId: this.AudienciaId          
        }
        
        comun.SeEstaCargandoInformacion(false);
        axios.post(api.conexion + api.Forseti.sistema.audiencias.audienciasPorVerificar.GuardarPermisoEnAudienciaPorVerificar,
          peticion,
          comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
        ).then(async respuesta => {
          if (respuesta.data.SiHayError) {
            console.log(respuesta);
            comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
          } else {
            this.busquedaAudiencia();
            this.limpiarDatos();
            comun.mensajeDeAlerta("El permiso se guardó correctamente.", null, null);                        
          }
          comun.SeEstaCargandoInformacion(false);
        })
        .catch(e => {
            console.log("No Hay Respuesta del Servidor", e);
            comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
        });
      },
      async busquedaAudiencia() {
        comun.SeEstaCargandoInformacion(true);
        let _this = this;

        let peticion = {
          AudienciaId: this.AudienciaId,
          BaseDeDatosProvenienteId: this.BaseDeDatosProvenienteId
        }

        axios.post(api.conexion + api.Forseti.sistema.audiencias.audienciasPorVerificar.ObtenAudienciaPorVerificar,
          peticion,
          comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
        ).then(async respuesta => {
          if (respuesta.data.SiHayError) {
            console.log(respuesta);
            comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
          } else {
            //CargarDatos de audiencia            
            this.Audiencia = respuesta.data.AudienciaPorVerificar;
            await this.cargaRelaciones();
            await this.cargaJueces();
            await this.cargaSesiones();
            await this.cargaPermisos();            
            this.nVideos = this.Audiencia.SesionesDeLasAudiencias.length;
            
          }
          comun.SeEstaCargandoInformacion(false);
        })
          .catch(e => {
            console.log("No Hay Respuesta del Servidor", e);
            comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
          });
      },
      formatoNombrePersonalidad(value) {        
        var Nombre = "";
        if (value != null && value != undefined) {
          switch (parseInt(value.TipoPersona.TipoPersonaId)) {
            case 1: //Autoridad
              Nombre = value.Autoridad.Institucion;
              break;
            case 2: //Física
              Nombre = (value.Fisica.Nombres == null || value.Fisica.Nombres == "" ? value.Fisica.Nombre : value.Fisica.Nombres) +
                (value.Fisica.ApellidoPaterno != "" && value.Fisica.ApellidoPaterno != null ? " " + value.Fisica.ApellidoPaterno : "") +
                (value.Fisica.ApellidoMaterno != "" && value.Fisica.ApellidoMaterno != null ? " " + value.Fisica.ApellidoMaterno : "");
              break;
            case 3: //Moral
              Nombre = value.Moral.Nombre;
              break;
            default:
              Nombre = "Sin Victima";
              break;
          }
        } else {
          if (value.ResulteResponsable)
            Nombre = "Sin Victima";
        }
        return Nombre;
      },
      async cargaRelaciones() {        
        let _this = this;
        this.Datos.Relaciones = [];
        if (this.Audiencia.AudienciaId != null && this.Audiencia.AudienciaId > 0) {
          this.Audiencia.RelacionesDeLaAudiencia.forEach((element) => {            
            _this.Datos.Relaciones.push({
              Imputado: this.formatoNombrePersonalidad(element.Imputado.DatosGenerales),
              Victima: this.formatoNombrePersonalidad(element.Victima.DatosGenerales),
              Delito: element.Delito
            });
          });
        }
      },
      async cargaJueces() {
        let _this = this;
        this.Datos.Jueces = [];
        if (this.Audiencia.AudienciaId != null && this.Audiencia.AudienciaId > 0) {          
          this.Audiencia.JuecesEnAudiencia.forEach((element) => {            
            _this.Datos.Jueces.push({
              Nombre: this.formatoNombrePersonalidad({ TipoPersona: { TipoPersonaId: 2 }, Fisica: element.Juez }),
              Tipo: element.TipoJuez
            });
          });
        }
      },
      async cargaSesiones() {        
        let _this = this;
        this.Datos.Sesiones = [];
        if (this.Audiencia.AudienciaId != null && this.Audiencia.AudienciaId > 0) {          
          this.Audiencia.SesionesDeLasAudiencias.forEach((element) => {
            _this.Datos.Sesiones.push({
              SesionDeLaAudienciaId: element.SesionDeLaAudienciaId,
              Sala: element.Sala,
              PruebaRealizada: element.PruebaRealizada,
              VideoDePruebaRealizado: element.VideoDePruebaRealizado,
              FechaDeInicio: element.FechaDeInicio != null ? moment(element.FechaDeInicio).format('DD/MM/YYYY HH:mm:ss') : "SIN FECHA",
              FechaDeFinalizacion: element.FechaDeFinalizacion != null ? moment(element.FechaDeFinalizacion).format('DD/MM/YYYY HH:mm:ss') : "SIN FECHA",
              SeHanCreadoLosVideos: element.SeHanCreadoLosVideos, 
              LocalizacionDeLosVideos: element.LocalizacionDeLosVideos,
              RutasDeVideos: element.RutasDeVideos
            });
          });
        }
      },
      async cargaPermisos() {
        let _this = this;
        this.Datos.Permisos = [];
        if (this.Audiencia.AudienciaId != null && this.Audiencia.AudienciaId > 0) {          
          this.Audiencia.PermisosDeLaAudiencia.forEach((element) => {            
            _this.Datos.Permisos.push({
              PermisoId: element.PermisoDeLaAudienciaId,
              FechaDeEntrega: element.FechaDeEntrega != null ? moment(element.FechaDeEntrega).format('DD/MM/YYYY HH:mm:ss') : "SIN FECHA",
              NombrePersonaAutorizada: element.NombreCompleto,
              NombrePersonaQueRecibe: element.NombreCompletoDeQuienLoRecibio,
              Entregado: element.Entregado,
              TipoIdentificacion: element.TipoIdentificacion,
              Folio: element.FolioDeLaIdentificacion
            });
          });
        }
      },
      concatenarVideosYDescargar(){
        let rutaFinal = '//'+ this.Audiencia.Sala.IP + '/Forseti/' + this.Audiencia.Area.Abreviatura + '/' + this.Audiencia.Consecutivo.substring(5,9) + '/' + this.Audiencia.TipoDocumento.Nombre.replace(" ","_") + '/' + this.Audiencia.Consecutivo.substring(0,4) + this.Audiencia.Consecutivo.substring(5,9) + '/' + this.Audiencia.AudienciaId + '/'
        var NombreArchivo = rutaFinal + this.Audiencia.Area.Abreviatura + "_" + this.Audiencia.TipoDocumento.Nombre.replace(" ","_") + "_" + this.Audiencia.Consecutivo.substring(0,4) + this.Audiencia.Consecutivo.substring(5,9) + "_EN_" +moment(this.Audiencia.FechaAudiencia).format('DD-MM-YYYY') +  ".mp4"
        var Archivos = [];
        this.Audiencia.SesionesDeLasAudiencias.forEach((element)=>{
          Archivos.push({'Ruta': element.RutasDeVideos[0].Ruta})
        });
        //comun.SeEstaCargandoInformacion(true);        
        const parametros = {
          "Archivos": Archivos,
          "Nombre": NombreArchivo
        };

        bootbox.confirm({
          title: "Mensaje del sistema",
          message: "¿De acuerdo al numero de sesiones y la duración de ellas, esta operación puede tardar algunos minutos, desea generar y descargar video?",
          buttons: {
            cancel: {
              label: '<i class="fa fa-times"></i>&nbsp;&nbsp;No'
            },
            confirm: {
              label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Continuar'
            }
          },
          callback: (respuesta) => {
            if (respuesta) {
              comun.SeEstaCargandoInformacion(true);
              axios.post(
                'http://' + this.Audiencia.Sala.IP + this.Audiencia.Sala.PuertoDeGrabacion + "/ConcatenarVideos",
                parametros,
                comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
                ).then(respuesta => {
                  if (respuesta.data.Error) {
                    console.log(respuesta);
                    comun.mensajeDeAlerta(respuesta.data.Mensaje, null, null);
                    comun.SeEstaCargandoInformacion(false);
                  } else {
                    comun.SeEstaCargandoInformacion(false);
                    if (respuesta.data.Satisfactorio==true)
                    {
                      window.open(api.conexion + api.Comun.funcion.DescargarArchivo + "?rutaDelArchivo="+ NombreArchivo, '_blank');
                    }
                  }
                }
                ).catch(excepcion => {
                  console.log(excepcion);
                  comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                  comun.SeEstaCargandoInformacion(false);
                });
                  }
                }
              });
      },
      ejecutaMergeDeLaGrabacion: async function(Sesion) {
        return axios.post(
          'http://' + Sesion.Sala.IP + Sesion.Sala.PuertoDeGrabacion + api.Forseti.sistema.audiencias.audienciaspendientes.EjecutarFinalizacionDeGrabacionDeSala,
          {"Ruta": Sesion.RutasDeVideos[0].Ruta }, //Agregado para enviar ruta en caso que la grabacion cerrara y quedara en estatus de Sesion origina {}
          comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
          ).then(respuesta => {
            if (respuesta.Error != undefined) {
              console.log(respuesta);
              comun.mensajeDeAlerta(respuesta.Error, null, null);
              throw respuesta
            } else {
              return respuesta;
            }
          }
          ).catch(excepcion => {
            console.log(excepcion);
            comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
            comun.SeEstaCargandoInformacion(false);
          });
      }
    },
    mounted() {
      if (this.AudienciaId != null && this.AudienciaId != undefined && this.AudienciaId > 0) {
        this.busquedaAudiencia();
      }
    }
  }
</script>

<style scoped>
  .padding-div-low {
    padding-top: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Forseti/Audiencias/PanelDeAudienciasPorVerificar/_Detalles.vue